module.exports = __webpack_public_path__ + "media/application/images/ce-logo-36ec982a44430af0736a27282ad17c20.svg";